"use client";

import { c as _c } from "react/compiler-runtime";
import { Autocomplete, AutocompleteItem } from "@dc/ui/components";
import { useTranslations } from "next-intl";
import type { FC } from "react";
interface TeamSwitcherAutocompleteProps {
  teams: Array<{
    id: string;
    name: string;
  }>;
  selectedTeamId?: string | null;
  isLoading?: boolean;
  isUpdating?: boolean;
  hasSingleTeam?: boolean;
  onSelectionChange: (teamId: string) => void;
}
export const TeamSwitcherAutocomplete: FC<TeamSwitcherAutocompleteProps> = t0 => {
  const $ = _c(29);
  const {
    teams,
    selectedTeamId,
    isLoading,
    isUpdating,
    hasSingleTeam,
    onSelectionChange
  } = t0;
  const t = useTranslations("navigation.team_switcher");
  const effectiveSelectedId = selectedTeamId || teams[0]?.id || null;
  let t1;
  if ($[0] !== effectiveSelectedId || $[1] !== teams) {
    let t2;
    if ($[3] !== effectiveSelectedId) {
      t2 = team => team.id === effectiveSelectedId;
      $[3] = effectiveSelectedId;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = teams.find(t2);
    $[0] = effectiveSelectedId;
    $[1] = teams;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const selectedTeam = t1;
  const t2 = `team-autocomplete-${effectiveSelectedId}`;
  let t3;
  if ($[5] !== t) {
    t3 = t("team");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = selectedTeam?.name || "";
  const t5 = hasSingleTeam || isLoading || isUpdating;
  let t6;
  if ($[7] !== isLoading || $[8] !== t) {
    t6 = isLoading ? t("loading") : t("select_team");
    $[7] = isLoading;
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t("team_selector");
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      base: "text-zinc-300!",
      listboxWrapper: "max-h-[400px]",
      selectorButton: "text-zinc-300!"
    };
    t9 = {
      classNames: {
        label: "text-zinc-300!"
      }
    };
    $[12] = t8;
    $[13] = t9;
  } else {
    t8 = $[12];
    t9 = $[13];
  }
  let t10;
  if ($[14] !== effectiveSelectedId || $[15] !== onSelectionChange) {
    t10 = key => {
      const selectedKey = key as string;
      if (selectedKey && selectedKey !== effectiveSelectedId) {
        onSelectionChange(selectedKey);
      }
    };
    $[14] = effectiveSelectedId;
    $[15] = onSelectionChange;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== teams) {
    t11 = teams.map(_temp);
    $[17] = teams;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== effectiveSelectedId || $[20] !== t10 || $[21] !== t11 || $[22] !== t2 || $[23] !== t3 || $[24] !== t4 || $[25] !== t5 || $[26] !== t6 || $[27] !== t7) {
    t12 = <Autocomplete key={t2} label={t3} variant="bordered" size="sm" selectedKey={effectiveSelectedId} defaultInputValue={t4} isDisabled={t5} placeholder={t6} aria-label={t7} classNames={t8} inputProps={t9} onSelectionChange={t10}>{t11}</Autocomplete>;
    $[19] = effectiveSelectedId;
    $[20] = t10;
    $[21] = t11;
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
function _temp(team_0) {
  return <AutocompleteItem key={team_0.id} textValue={team_0.name}><span className="whitespace-pre-wrap">{team_0.name}</span></AutocompleteItem>;
}